<template>
    <div class="breadcrumb-container">
        <nav class="breadcrumb">
            <ul>
                <li v-for="item in items" :key="item.id">
                    <span
                        :class="{ active: canInteractWith(item.id).active, disabled: !canInteractWith(item.id).clickable }"
                        @click="canInteractWith(item.id).clickable && navigateTo(item.id)"
                        :style="{ cursor: canInteractWith(item.id).clickable ? 'pointer' : 'default' }"
                    >
                        {{ $ml.get(item.label) }}
                    </span>
                    <span v-if="item !== items[items.length - 1]">
                        <img class="bank-list__chevron" src="@/assets/img/right.svg" alt="" tabindex="-1" />
                    </span>
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
  name: 'BreadCrumb',

  computed: {
    visitedIndexes() {
      return this.$store.getters['stepsVisited/visitedIndexes'];
    },
    isPaymentValid() {
      return (
        this.$store.state.payment.PaymentType !== null &&
        this.$store.state.payment.PaymentMethodId !== null
      );
    },
    activeId() {
      const currentItem = this.items.find(item =>
        Array.isArray(item.nameRouter)
          ? item.nameRouter.includes(this.$route.name)
          : item.nameRouter === this.$route.name
      );
      return currentItem ? currentItem.id : null;
    },
  },

  mounted() {
    const activeIndex = this.items.findIndex(item => item.id === this.activeId);
    for (let i = 0; i <= activeIndex; i++) {
      const id = this.items[i].id;
      this.$store.dispatch('stepsVisited/addVisitedIndex', id);
    }
  },

  methods: {
    navigateTo(id) {
      const item = this.items.find(item => item.id === id);
      if (item && item.nameRouter) {
        this.$store.dispatch('pipelineV2/pushTo', Array.isArray(item.nameRouter) ? item.nameRouter[0] : item.nameRouter);
        this.$store.dispatch('stepsVisited/addVisitedIndex', id);
      }
    },
    canInteractWith(id) {
      const activeIndex = this.items.findIndex(item => item.id === this.activeId);
      const itemIndex = this.items.findIndex(item => item.id === id);
      const isActive =
        this.visitedIndexes.includes(id) || itemIndex <= activeIndex;

        if (id === 'Review') {
        const paymentType = this.$store.state.payment.PaymentType;
        const securityCode = this.$store.state.cardPayment.SecurityCode;
        const numberOfInstallments = this.$store.state.payment.NumberOfInstallments;

        const isPaymentTypeValid = [1, 4, 8, 99].includes(paymentType);
        const isSecurityCodeValid = securityCode !== null && securityCode.trim() !== '';
        const hasValidInstallments = numberOfInstallments > 0;

        return {
          active: isActive && this.isPaymentValid && (!isPaymentTypeValid || isSecurityCodeValid) && hasValidInstallments,
          clickable: isActive && this.isPaymentValid && (!isPaymentTypeValid || isSecurityCodeValid) && hasValidInstallments,
        };
      }

      return {
        active: isActive,
        clickable: isActive,
      };
    },
  },

  data() {
    return {
      items: [
        { id: 'Identification', label: 'breadcrumbIdentification', nameRouter: 'Identification' },
        { id: 'ShippingAddress', label: 'breadcrumbDelivery', nameRouter: 'ShippingAddress' },
        {
          id: 'Payment',
          label: 'breadcrumbPayment',
          nameRouter: [
          'ChangePaymentType', 'CardDataCred',
          'CardDataDebit', 'CardDataVoucher',
          'ChangePixType', 'PixOpenFinanceBanksList',
          'QrCodePayInstallments', 'UserValidationC2P',
          'CardListC2P', 'IdLookUpAuthenticationC2P',
          'UnifiedCardPaymentC2P', 'CardDataEloVoucher',
          'GooglePayCardInstallments', 'GooglePayBillingAddress',
          'ApplePayCardInstallments'
          ]
        },
        { id: 'Review', label: 'breadcrumbReview', nameRouter: 'PersonalData' },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb-container {
  width: 100%;
}
.breadcrumb {
  display: flex;
  margin-bottom: 32px;
  background-color: transparent;
  padding: 0;

  @media screen and (max-width: 1024px) {
		margin-bottom: 24px;
    }
}
.breadcrumb ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
}
.breadcrumb li {
  display: flex;
  align-items: center;
}
.breadcrumb li span {
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	margin-right: 8px;
	cursor: pointer;

	@media screen and (max-width: 1024px) {
		font-size: 12px;
    }
}
.breadcrumb li span:not(:last-child) {
  margin-right: 8px;
}
.breadcrumb li span.active {
  color: #2F363E;
}
.breadcrumb li span.disabled {
  color: #96A4B4;
  pointer-events: none;
}
</style>
